import { IBaseLabelValue } from "@/interfaces";
import { cn } from "@/lib";

interface IInputDataContentProps {
  content: IBaseLabelValue[];
  className?: string;
  itemClassName?: string;
}

const InputDataContent: React.FC<IInputDataContentProps> = ({
  content,
  className,
  itemClassName,
}) => {
  return (
    <>
      <ul
        className={cn(
          "shadow-main mb-10 flex flex-col gap-6 space-y-1 rounded-xl p-8",
          className,
        )}
      >
        {content.map((item, index) => (
          <li key={index} className={cn("flex-between", itemClassName)}>
            <span>{item.label}</span>
            <span className="text-primary-main">{item.value}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default InputDataContent;
